import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import SessionConflictModal from './SessionConflictModal';
import OtpForm from './OtpForm';
import { handleConfirmSession } from 'utils/tools';

/** Standalone OTP page (kept for deep links); the login card shows the same form inline. */
const VerifyOtp = () => {
  const navigate = useNavigate();
  const [sessionModal, setSessionModal] = useState(false);
  const [sessionConflictData, setSessionConflictData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const mfaToken = sessionStorage.getItem('mfaToken');
  const loginId = sessionStorage.getItem('loginId');

  useEffect(() => {
    if (!mfaToken || !loginId) navigate('/login');
  }, [mfaToken, loginId, navigate]);

  if (!mfaToken || !loginId) return null;

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card>
              <CardBody className="p-4">
                <OtpForm
                  loginId={loginId}
                  mfaToken={mfaToken}
                  onBack={() => navigate('/login')}
                  onSessionConflict={(data) => {
                    setSessionConflictData(data);
                    setSessionModal(true);
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <SessionConflictModal
        confirmLoading={confirmLoading}
        setSessionModal={setSessionModal}
        sessionModal={sessionModal}
        sessionConflictData={sessionConflictData}
        handleCancelSession={() => {
          setConfirmLoading(true);
          setSessionModal(false);
          navigate('/login');
        }}
        handleConfirmSession={() => handleConfirmSession(navigate, sessionConflictData)}
      />
    </div>
  );
};

export default VerifyOtp;
